module.exports = __webpack_public_path__ + "static/media/LogoHelenLabs2.a28ba49c.svg";